import { render } from "./VDivider.vue?vue&type=template&id=6d61d42e"
const script = {}

import "./VDivider.vue?vue&type=style&index=0&id=6d61d42e&lang=sass"

import exportComponent from "/home/gitlab-runner/builds/dhPKyzHk/0/den59k/reply200-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__